/* eslint-disable consistent-return */
import DocumentService from '../services/DocumentService';

export default async function downloadDocument(docId, docName) {
  const docWithSignedUrl = await DocumentService.getDocument(docId);

  let url = docWithSignedUrl.signed_url;

  if (!url) {
    return false;
  }

  if (!url.startsWith('https') && docWithSignedUrl.private_document?.url) {
    url = docWithSignedUrl.private_document.url;
  }

  const downloadLink = document.createElement('a');

  downloadLink.href = url;
  downloadLink.download = docName;
  downloadLink.target = '_blank';
  downloadLink.rel = 'noopener noreferrer';

  document.body.appendChild(downloadLink);

  downloadLink.click();

  document.body.removeChild(downloadLink);
}
